import React, { useState } from 'react';
import { Heart, X, Instagram, Mail, User, Phone } from 'lucide-react';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

const Footer = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);

  const handleInstagramClick = () => {
    window.open(
      'https://www.instagram.com/neuromind.solutions?igsh=cGlnZjFucmFjbGZi',
      '_blank'
    );
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/593969756637', '_blank'); // número demo
  };

  return (
    <footer className="relative py-12 bg-background border-t border-primary/20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Left */}
          <div className="flex items-center gap-2 text-muted-foreground text-sm">
            <span>Hecho con</span>
            <Heart className="w-4 h-4 text-primary fill-primary" />
            <span>para los niños</span>
          </div>

          {/* Center */}
          <nav>
            <button
              onClick={() => setIsContactOpen(true)}
              className="text-muted-foreground hover:text-foreground transition-colors text-sm font-medium"
            >
              Contacto
            </button>
          </nav>

          {/* Right */}
          <div className="text-xs text-muted-foreground/80">
            © 2026 Derechos Reservados | Glich Business
          </div>
        </div>
      </div>

      {/* Contact Modal */}
      <Dialog open={isContactOpen} onOpenChange={setIsContactOpen}>
        <DialogContent className="
  bg-white/25
  border border-white/30
  backdrop-blur-2xl
  max-w-md
  p-0
  overflow-hidden
  [&>button]:hidden
"

        >
          {/* Close Button */}
          <button
            onClick={() => setIsContactOpen(false)}
            className="absolute top-4 right-4 text-primary-foreground/70 hover:text-primary-foreground transition-colors z-10"
          >
            <X className="w-6 h-6" />
          </button>

          {/* Soft glass gradient */}
          <div className="absolute inset-0 bg-gradient-to-br from-white/10 via-transparent to-white/5 pointer-events-none" />

          <div className="relative p-8">
            <DialogHeader className="mb-8">
              <DialogTitle className="text-2xl font-bold text-primary-foreground text-center">
                Contacto
              </DialogTitle>
            </DialogHeader>

            <div className="space-y-4">
              {/* Nombre */}
              <div className="flex items-center gap-4 p-4 rounded-xl bg-white/10 border border-white/20">
                <div className="p-3 rounded-xl bg-white/10 border border-white/20">
                  <User className="w-5 h-5 text-primary-foreground" />
                </div>
                <div>
                  <p className="text-primary-foreground/60 text-sm">
                    Neuropsicóloga Clínica
                  </p>
                  <p className="text-primary-foreground font-medium">
                    Karla Llerena
                  </p>
                </div>
              </div>

              {/* Instagram */}
              <button
                onClick={handleInstagramClick}
                className="w-full flex items-center gap-4 p-4 rounded-xl bg-white/10 border border-white/20 hover:bg-white/20 transition-all"
              >
                <div className="p-3 rounded-xl bg-white/10 border border-white/20">
                  <Instagram className="w-5 h-5 text-primary-foreground" />
                </div>
                <div className="text-left">
                  <p className="text-primary-foreground/60 text-sm">
                    Instagram
                  </p>
                  <p className="text-primary-foreground font-medium">
                    @neuromind.solutions
                  </p>
                </div>
              </button>

              {/* WhatsApp */}
              <button
                onClick={handleWhatsAppClick}
                className="w-full flex items-center gap-4 p-4 rounded-xl bg-white/10 border border-white/20 hover:bg-white/20 transition-all"
              >
                <div className="p-3 rounded-xl bg-white/10 border border-white/20">
                  <Phone className="w-5 h-5 text-primary-foreground" />
                </div>
                <div className="text-left">
                  <p className="text-primary-foreground/60 text-sm">
                    WhatsApp
                  </p>
                  <p className="text-primary-foreground font-medium">
                    +593 969756637
                  </p>
                </div>
              </button>

              {/* Email */}
              <div className="flex items-center gap-4 p-4 rounded-xl bg-white/10 border border-white/20">
                <div className="p-3 rounded-xl bg-white/10 border border-white/20">
                  <Mail className="w-5 h-5 text-primary-foreground" />
                </div>
                <div>
                  <p className="text-primary-foreground/60 text-sm">
                    Correo electrónico
                  </p>
                  <p className="text-primary-foreground font-medium">
                    sambogirls@gmail.com
                  </p>
                </div>
              </div>
            </div>

            <Button
              onClick={() => setIsContactOpen(false)}
              className="w-full mt-8 bg-primary/80 hover:bg-primary text-primary-foreground py-4 rounded-full transition-all"
            >
              Cerrar
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </footer>
  );
};

export default Footer;
